module.exports = __webpack_public_path__ + "img/base_restauration_auberge.92dae672.svg";